"use client";
import React, { Fragment } from "react";
import PageLayout from "@/layouts/pageLayout";
import PublicCloudTabs from "@/components/pageTabs/publicCloudTabs";
import KubernetesPricing from "./components/pricing";
import Hero from "./components/hero";
import Intro from "./components/intro";
import WhyOnemind from "./components/whyOnemind";
import KubernetesBenefits from "./components/features";
import UseCases from "./components/useCases";
import Implementation from "./components/implementation";
import KubernetesTable from "./components/comparison";
import Faqs from "./components/faqs";

const KubernetesPage = () => {
  return (
    <Fragment>
      <Hero />
      <PageLayout marginTop={0}>
        <PublicCloudTabs />
        <Intro />
      </PageLayout>
      <WhyOnemind />
      <PageLayout showContactForm marginTop={0} spacing={16}>
        <KubernetesPricing />
        <KubernetesBenefits />
        <UseCases />
        <Implementation />
        <KubernetesTable />
        <Faqs />
      </PageLayout>
    </Fragment>
  );
};

export default KubernetesPage;
